<template>
  <img :src="logoSrc" class="avatar-s" @error="imgUrlAlt" />
</template>

<script>
import default_img from '~/assets/images/me01.png';
export default {
  name: 'UserAvatar',
  props: {
    src:'',
    className:''
  },
  computed:{
    logoSrc(){
      if(!this.src){
        return default_img;
      }
      return this.src;
    }
  },
  data() {
    return {
      default_img,
    };
  },
  methods:{
    imgUrlAlt(event) {
      event.target.src = default_img;
    }
  }
};
</script>

<style scoped>

</style>
